import React from "react";
import DataTablePage from "@/components/common/DataTablePage";

export default function ReportsPage() {
  return (
    <DataTablePage
      collection="reports"
      eyebrow="Insights"
      title="Weekly Reports"
      subtitle="Log weekly performance summaries and highlights. Ask the AI Manager to draft these from your data."
      emptyDefault={{ status: "draft" }}
      columns={[
        { key: "week", label: "Week", type: "text" },
        { key: "summary", label: "Summary", type: "textarea" },
        { key: "highlights", label: "Highlights", type: "textarea" },
        { key: "status", label: "Status", type: "badge", options: ["draft", "published"] },
      ]}
    />
  );
}
